import { z } from 'zod';
export var YstMentalHealthGeneralResource = {
    TIPS_FOR_TALKING_TO_TEENS: 'TIPS_FOR_TALKING_TO_TEENS',
    RECOGNIZING_WARNING_SIGNS: 'RECOGNIZING_WARNING_SIGNS',
    TEEN_MENTAL_HEALTH: 'TEEN_MENTAL_HEALTH',
    TEEN_DEPRESSION: 'TEEN_DEPRESSION',
    CRISIS: 'CRISIS'
};
export var YstMentalHealthGeneralResourceLabels = {
    TIPS_FOR_TALKING_TO_TEENS: 'Tips for talking with teens',
    RECOGNIZING_WARNING_SIGNS: 'Recognizing warning signs',
    TEEN_MENTAL_HEALTH: 'Teen mental health',
    TEEN_DEPRESSION: 'Teen depression',
    CRISIS: 'Emergency Resources'
};
export var YstMentalHealthConcern = {
    ADHD: 'ADHD',
    AGGRESSION: 'AGGRESSION',
    ALCOHOL_ABUSE: 'ALCOHOL_ABUSE',
    AUTISM: 'AUTISM',
    BIPOLAR_DISORDER: 'BIPOLAR_DISORDER',
    BORDERLINE_PERSONALITY_DISORDER: 'BORDERLINE_PERSONALITY_DISORDER',
    BULLYING: 'BULLYING',
    CONDUCT_DISORDER: 'CONDUCT_DISORDER',
    DEPRESSION: 'DEPRESSION',
    DISCRIMINATION: 'DISCRIMINATION',
    DRUG_ABUSE: 'DRUG_ABUSE',
    EATING_DISORDER: 'EATING_DISORDER',
    FIREARM_SAFETY: 'FIREARM_SAFETY',
    GENERAL_ANXIETY: 'GENERAL_ANXIETY',
    GRIEF: 'GRIEF',
    MENTAL_HEALTH_CONCERNS: 'MENTAL_HEALTH_CONCERNS',
    OCD: 'OCD',
    PSYCHOSIS: 'PSYCHOSIS',
    PTSD: 'PTSD',
    SELF_HARM: 'SELF_HARM',
    SLEEP_PROBLEMS: 'SLEEP_PROBLEMS',
    SOCIAL_ANXIETY: 'SOCIAL_ANXIETY',
    SOCIAL_MEDIA: 'SOCIAL_MEDIA',
    STRESS_MANAGEMENT: 'STRESS_MANAGEMENT',
    SUICIDE_RISK: 'SUICIDE_RISK',
    TRAUMA: 'TRAUMA'
};
export var YstMentalHealthConcerns = z.object({
    generalResources: z.partialRecord(z.nativeEnum(YstMentalHealthGeneralResource), z.coerce.boolean()).optional(),
    concerns: z.partialRecord(z.nativeEnum(YstMentalHealthConcern), z.boolean()),
    medication: z.object({
        status: z.enum([
            'YES',
            'NO',
            'SOON',
            'UNKNOWN'
        ]).nullish(),
        description: z.string()
    }),
    therapy: z.object({
        status: z.enum([
            'YES',
            'NO',
            'SOON',
            'UNKNOWN'
        ]).nullish(),
        description: z.string()
    }),
    treatmentResponse: z.union([
        z.number().int().min(0).max(4).nullish(),
        z.string().refine(function(value) {
            var numberValue = Number(value);
            return !Number.isNaN(numberValue) && Number.isInteger(numberValue) && numberValue >= 0 && numberValue <= 4;
        }, {
            message: 'treatmentResponse must be an integer between 0 and 4',
            path: [
                'treatmentResponse'
            ]
        }).transform(function(value) {
            return Number(value);
        })
    ])
}).prefault(function() {
    return {
        concerns: {},
        medication: {
            status: null,
            description: ''
        },
        therapy: {
            status: null,
            description: ''
        },
        treatmentResponse: null
    };
});
export var YstMentalHealthConcernLabels = {
    ADHD: 'ADHD',
    AGGRESSION: 'Aggression',
    ALCOHOL_ABUSE: 'Alcohol Misuse',
    AUTISM: 'Autism',
    BIPOLAR_DISORDER: 'Bipolar Disorder',
    BORDERLINE_PERSONALITY_DISORDER: 'Borderline Personality Disorder',
    BULLYING: 'Dealing with Bullying',
    CONDUCT_DISORDER: 'Conduct Disorder',
    DEPRESSION: 'Depression',
    DISCRIMINATION: 'Discrimination',
    DRUG_ABUSE: 'Drug Use',
    EATING_DISORDER: 'Eating Disorders',
    FIREARM_SAFETY: 'Firearm Safety',
    GENERAL_ANXIETY: 'Anxiety',
    GRIEF: 'Coping with Grief',
    MENTAL_HEALTH_CONCERNS: 'Mental Health Concerns',
    OCD: 'OCD',
    PSYCHOSIS: 'Psychosis',
    PTSD: 'PTSD',
    SELF_HARM: 'Self-Harm',
    SLEEP_PROBLEMS: 'Sleep Problems',
    SOCIAL_ANXIETY: 'Social Anxiety',
    SOCIAL_MEDIA: 'Social Media',
    STRESS_MANAGEMENT: 'Stress Management',
    SUICIDE_RISK: 'Suicide Risk',
    TRAUMA: 'Trauma'
};
export var YstTreatmentResponseLabel = {
    0: 'Very poorly',
    1: 'Poorly',
    2: 'No change',
    3: 'Well',
    4: 'Very well'
};
